import React from "react";

const TermsPage = () => {
  return (
    <div className="legal-page">
      <div className="article-container">
        <header className="article-header">
          <p className="section-label">Legal</p>
          <h1>Terms of Service</h1>
          <div className="article-meta">
            <span>Effective Date: January 1, 2025</span>
          </div>
        </header>

        <div className="article-body">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using the Hayden Bulk Tech Labs website
            (haydenbulktechlabs.com) and any associated services, you agree to
            be bound by these Terms of Service. If you do not agree to these
            terms, please do not use our website or services.
          </p>

          <h2>2. Description of Services</h2>
          <p>
            Hayden Bulk Tech Labs provides technology consulting, software
            development services, and digital products including but not limited
            to ChattyBooks, PictureMeIn, and Farty Unicorn. The specific terms
            of any engagement will be outlined in a separate agreement between
            Hayden Bulk Tech Labs and the client.
          </p>

          <h2>3. Use of Website</h2>
          <p>
            You may use this website for lawful purposes only. You agree not to
            use the website in any way that could damage, disable, or impair the
            site or interfere with any other party's use of the website. You may
            not attempt to gain unauthorized access to any part of the website
            or any systems or networks connected to the website.
          </p>

          <h2>4. Intellectual Property</h2>
          <p>
            All content on this website, including text, graphics, logos, images,
            and software, is the property of Hayden Bulk Tech Labs or its
            content suppliers and is protected by applicable intellectual
            property laws. You may not reproduce, distribute, or create
            derivative works from any content on this website without prior
            written consent.
          </p>

          <h2>5. Contact Form and Communications</h2>
          <p>
            When you submit information through our contact form or communicate
            with us via email, you consent to receiving responses from Hayden
            Bulk Tech Labs. We will use the information you provide solely for
            the purpose of responding to your inquiry and will not share it with
            third parties without your consent.
          </p>

          <h2>6. Disclaimer of Warranties</h2>
          <p>
            This website and its content are provided on an "as is" and "as
            available" basis. Hayden Bulk Tech Labs makes no warranties, express
            or implied, regarding the operation of this website or the accuracy
            of the information, content, or materials included on the website.
          </p>

          <h2>7. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Hayden Bulk Tech Labs shall
            not be liable for any damages arising from the use of or inability
            to use this website or services, including but not limited to
            direct, indirect, incidental, punitive, and consequential damages.
          </p>

          <h2>8. Third-Party Links</h2>
          <p>
            This website may contain links to third-party websites. Hayden Bulk
            Tech Labs is not responsible for the content, privacy policies, or
            practices of any third-party websites. Visiting these links is at
            your own risk.
          </p>

          <h2>9. Changes to Terms</h2>
          <p>
            Hayden Bulk Tech Labs reserves the right to modify these Terms of
            Service at any time. Changes will be effective immediately upon
            posting to this page. Your continued use of the website after
            changes are posted constitutes your acceptance of the updated terms.
          </p>

          <h2>10. Governing Law</h2>
          <p>
            These Terms of Service are governed by and construed in accordance
            with the laws of the Province of Ontario, Canada, without regard to
            conflict of law principles.
          </p>

          <h2>11. Contact Information</h2>
          <p>
            If you have any questions about these Terms of Service, please
            contact us at contact@haydenbulktechlabs.com.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
